(() => {
  if (window.drSalesEventsInstalled) return;
  window.drSalesEventsInstalled = true;

  document.addEventListener('click', e => {
    const menu = e.target.closest('.dr-menu');

    if (menu) {
      const nav = document.getElementById(
        menu.getAttribute('aria-controls')
      );
      if (!nav) return;

      const open = menu.getAttribute('aria-expanded') !== 'true';

      menu.setAttribute('aria-expanded', String(open));
      menu.textContent = open ? 'Close' : 'Menu';
      nav.classList.toggle('open', open);

      if (window.matchMedia('(max-width: 760px)').matches) {
        nav.querySelectorAll('details').forEach(dropdown => {
          dropdown.open = open;
        });
      }

      return;
    }

    const navLink = e.target.closest('.dr-navigation a');

    if (navLink) {
      const nav = navLink.closest('nav');
      const button = nav.closest('header').querySelector('.dr-menu');

      nav.classList.remove('open');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Menu';
      }
    }

    const filter = e.target.closest('[data-filter]');

    if (filter) {
      const scope = filter.closest('.dr-work');
      if (!scope) return;

      scope.querySelectorAll('[data-filter]').forEach(button => {
        button.classList.toggle('active', button === filter);
        button.setAttribute(
          'aria-pressed',
          String(button === filter)
        );
      });

      scope.querySelectorAll('.project').forEach(project => {
        project.hidden =
          filter.dataset.filter !== 'all' &&
          project.dataset.category !== filter.dataset.filter;
      });

      return;
    }

    const project = e.target.closest('.dr-work .project');

    if (project) {
      const scope = project.closest('.dr-work');
      const dialog = scope.parentElement.querySelector('dialog');
      if (!dialog) return;

      const image = dialog.querySelector('img');
      image.src = project.dataset.image;
      image.alt = project.querySelector('img').alt;

      dialog.querySelector('p').textContent = project.dataset.title;

      if (!dialog.open) dialog.showModal();
      return;
    }

    const close = e.target.closest('dialog .close');

    if (close) {
      close.closest('dialog').close();
      return;
    }

    if (e.target.tagName === 'DIALOG') {
      const bounds = e.target.getBoundingClientRect();

      if (
        e.clientX < bounds.left ||
        e.clientX > bounds.right ||
        e.clientY < bounds.top ||
        e.clientY > bounds.bottom
      ) {
        e.target.close();
      }
    }

    document.querySelectorAll('.dr-work-menu[open]').forEach(dropdown => {
      const mobileMenuOpen =
        window.matchMedia('(max-width: 760px)').matches &&
        dropdown.closest('.dr-navigation')?.classList.contains('open');

      if (!mobileMenuOpen && !dropdown.contains(e.target)) {
        dropdown.open = false;
      }
    });
  });
})();
